export interface SessionPermissions {
  nominate: boolean;
  approveOrReject: boolean;
  viewOnly: boolean;
}

export const DEFAULT_SESSION_PERMISSIONS: SessionPermissions = {
  nominate: false,
  approveOrReject: false,
  viewOnly: false,
};

export type SessionPermissionKey = keyof SessionPermissions;
